import React from 'react';
import { Lock, Zap, Shield, CreditCard } from 'lucide-react';
import { Section, CTAButton } from './Shared';
export const EmotionalClose = () => {
  return <Section className="max-w-4xl" data-id="element-45">
      <div className="glass-panel p-6 md:p-12 rounded-3xl text-center bg-white/90 border-brand-gold/30 shadow-lg relative overflow-hidden" data-id="element-46">
        <div className="absolute top-0 left-0 w-24 h-24 bg-brand-gold/10 rounded-br-full -z-10" data-id="element-47"></div>
        <div className="absolute bottom-0 right-0 w-24 h-24 bg-brand-violet/10 rounded-tl-full -z-10" data-id="element-48"></div>

        <h2 className="text-2xl md:text-4xl font-display font-bold mb-8 text-brand-violetDark leading-tight" data-id="element-49">
          Hay dos versiones de vos.
        </h2>

        <div className="space-y-5 text-base md:text-lg text-brand-text/80 mb-10 max-w-2xl mx-auto" data-id="element-50">
          <p data-id="element-51">
            La que sigue trabajando con cuadernos sueltos, notas en WhatsApp y
            sesiones que dependen de lo que recordés esa mañana.
          </p>
          <p className="font-medium text-brand-violet" data-id="element-52">
            Y la que decide que su consulta merece estructura.
          </p>
          <p className="font-serif italic text-lg md:text-xl text-brand-burgundy" data-id="element-53">
            Porque vos ya tenés el conocimiento. Ya tenés la vocación. Ya tenés
            el compromiso.
            <br data-id="element-54" />
            Lo único que faltaba era el sistema.
          </p>
        </div>

        <h3 className="text-xl md:text-3xl font-display font-bold mb-8 text-brand-violetDark" data-id="element-55">
          ¿CON CUÁL EMPEZÁS?
        </h3>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-5 md:gap-6 mb-10" data-id="element-56">
          {/* Plan 1 */}
          <div className="glass-panel rounded-2xl p-6 md:p-7 border-brand-gold/30 bg-white/85 text-center flex flex-col" data-id="element-57">
            <h4 className="font-serif font-bold text-lg md:text-xl text-brand-violetDark mb-1" data-id="element-58">
              📘 KIT TERAPEUTA PRO™
            </h4>
            <div className="text-3xl md:text-4xl font-bold text-brand-violetDark mb-3" data-id="element-59">
              $19.990
            </div>
            <p className="text-sm text-brand-text/70 mb-5 flex-grow" data-id="element-60">
              Planificador de 30 días + 4 Bonos. Aplicá el sistema de
              organización desde hoy.
            </p>
            <CTAButton fullWidth className="text-sm md:text-base py-3.5" href="https://www.lumenakasha.com/cart/46928959963325:1" variant="gold" data-id="element-61">
              📘 → LO QUIERO $19.990
            </CTAButton>
          </div>

          {/* Plan 2 — featured */}
          <div className="glass-panel rounded-2xl p-6 md:p-7 border-2 border-brand-goldDark bg-white text-center flex flex-col relative animate-glow-pulse shadow-[0_0_34px_rgba(201,169,97,0.45)] md:scale-[1.04] z-[1] mt-3 md:mt-0" data-id="element-62">
            <div className="absolute -top-3.5 left-1/2 -translate-x-1/2 gold-gradient-bg text-brand-ink text-[10px] md:text-xs font-extrabold tracking-wider uppercase px-3.5 py-1 rounded-full shadow-md whitespace-nowrap inline-flex items-center gap-1" data-id="element-63">
              ⭐ Más elegido · Mejor opción
            </div>
            <p className="mt-3 mb-1 text-[11px] md:text-xs font-bold text-brand-goldDark tracking-wide" data-id="element-64">
              ✨ La opción más completa — el sistema + Marketing
            </p>
            <h4 className="font-serif font-bold text-lg md:text-xl text-brand-violet mb-1" data-id="element-65">
              🏆 KIT + MARKETING CONSCIENTE™
            </h4>
            <div className="text-3xl md:text-4xl font-bold text-brand-violet mb-3" data-id="element-66">
              $27.990
            </div>
            <p className="text-sm text-brand-text/70 mb-5 flex-grow" data-id="element-67">
              Todo lo anterior + estrategia completa para atraer pacientes
              ideales.
            </p>
            <CTAButton fullWidth className="text-sm md:text-base py-3.5 cta-shimmer relative overflow-hidden font-bold" href="https://www.lumenakasha.com/cart/46928972480701:1" variant="purple" data-id="element-68">
              🏆 → SÍ, LO QUIERO TODO — $27.990
            </CTAButton>
          </div>
        </div>

        <div className="flex flex-wrap items-center justify-center gap-x-4 gap-y-2 text-xs md:text-sm text-brand-muted mb-8" data-id="element-69">
          <div className="flex items-center" data-id="element-70">
            <Lock className="w-3.5 h-3.5 md:w-4 md:h-4 mr-1.5" data-id="element-71" /> Pago 100%
            seguro
          </div>
          <div className="flex items-center" data-id="element-72">
            <Zap className="w-3.5 h-3.5 md:w-4 md:h-4 mr-1.5" data-id="element-73" /> Acceso en 5
            minutos
          </div>
          <div className="flex items-center" data-id="element-74">
            <Shield className="w-3.5 h-3.5 md:w-4 md:h-4 mr-1.5" data-id="element-75" /> Garantía 7
            días
          </div>
          <div className="flex items-center" data-id="element-76">
            <CreditCard className="w-3.5 h-3.5 md:w-4 md:h-4 mr-1.5" data-id="element-77" /> Mercado
            Pago | Tarjeta | Transferencia
          </div>
        </div>

        <div className="text-sm text-brand-text/70 bg-brand-surfaceLight/60 p-5 md:p-6 rounded-2xl border border-brand-gold/20 space-y-3 text-left md:text-center" data-id="element-78">
          <p data-id="element-79">
            <strong className="text-brand-violetDark" data-id="element-80">P.D.:</strong> Si tenés
            dudas, escribinos a{' '}
            <a href="mailto:soportelumenakasha@gmail.com" className="text-brand-goldDark hover:underline font-medium" data-id="element-81">
              soportelumenakasha@gmail.com
            </a>{' '}
            o a{' '}
            <a href="https://instagram.com/lumen.akasha" className="text-brand-goldDark hover:underline font-medium" data-id="element-82">
              @lumen.akasha
            </a>
            . Te respondemos hoy.
          </p>
          <p className="italic text-brand-violet" data-id="element-83">
            El precio de lanzamiento sube pronto. El mejor momento para
            organizar tu práctica es ahora.
          </p>
        </div>
      </div>
    </Section>;
};